import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';

export const HOTSPOT_IMAGE_STYLE_SCHEMA = {
  accent: { default: '' },
  markerSize: { default: '2.75rem' },
  border: { default: () => ({ ...BORDERLESS_BORDER }) },
  shadow: { default: 'none' },
  panelBackground: { default: '' },
  panelWidth: { default: '22rem' },
  textStyles: { default: {} },
};
